import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ICustomer, IServiceError, IUserAccessPermissions } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { StorageManagerService } from './storage-manager.service';
import { Utilities } from './utilities';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {

    private accessSettings: IUserAccessPermissions;
    private permissionName: string;
    public hasPermissionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public lastLogonDateSourceSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    public permissionsSetSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(undefined);
    private applicationName = 'SSDrugProducts';

    constructor(private router: Router, private storage: StorageManagerService,
        private authenticationService: AuthenticationService, private storageManagerService: StorageManagerService) { }

    // To be replaced with the real data.
    private permissions: any = null;

    private getPermissions(): Observable<{} | string[]> {
        return of(this.storage.read('accessPermissions'));
    }

    // Checks whether the user has permission to the application or not
    public getPermisions(displayableId: string): any {

        const permissions$ = this.authenticationService.get(`${window.location.origin}/api/user/permissions?loginName=${displayableId}&appName=${this.applicationName}`);

        return permissions$;
    }

    public setAccessPermissions(email: string): any {

        let customer: any;
        let customerId: number;
        let url: string;

        if (email) {

            customer = this.storageManagerService.read('currentCustomer');

            if (customer && typeof customer !== 'object') {

                customer = JSON.parse(customer);
            }

            customerId = customer.customerId;

            url = `${window.location.origin}/api/User/AccessPermissions?loginName=${email}&applicationName=${this.applicationName}&customerId=${customerId}`;

            return this.authenticationService.get(url);
        }
    }
    hasPermission(objectAccessed: string) {

        // Get permissions for User/Access from the Api
        this.getPermissions()
            .pipe(
                tap((data: any) => {
                    if (!Utilities.IsUndefined(data)) {
                        this.permissions = data;
                    }
                }),
                catchError(err => this.handleHttpError(err)))
            .subscribe((permissions: string[]) => {
                // this.permissions = JSON.parse(permissions);
            });


        if (this.permissions && objectAccessed) {

            for (let i = 0; i < this.permissions.length; i++) {
                if (this.permissions[i] === objectAccessed) {
                    return true;
                }
            }
        }
        return false;
    }
    getSettings(): IUserAccessPermissions {

        // Get user access settings from the SSDrugProducts appsetting.json previously called by app-module and stored in the sessionStorage.
        this.accessSettings = this.storage.read('accessPermissions');

        if (this.accessSettings) {
            return this.accessSettings;
        }

        return new IUserAccessPermissions();
    }

  public hasAccessToAppVariant(appVariantName: string, customer: ICustomer): boolean {
    let hasAccessToAppVariant = false;
    if (customer.subscribedChannels !== undefined) {
      hasAccessToAppVariant = customer.subscribedChannels.find(app => app.applicationVariantName === appVariantName) !== undefined;
    }

    return hasAccessToAppVariant;
  }

    private handleHttpError(error: HttpErrorResponse): Observable<IServiceError> {

        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        const dataError = new IServiceError();
        dataError.errorNumber = error.error ? error.error.number : 0;
        dataError.message = errorMessage ? errorMessage : '';
        dataError.friendlyMessage = `Oops.. Something's wrong.. Please try again later.`;
        dataError.errorMessage = errorMessage ? errorMessage : '';
        dataError.errorStatus = error.status;
        dataError.url = error.url;

        // return an observable of an IServiceError object with a user friendly error message
        return throwError(dataError);
    }
}
